import React, { useEffect, useState, lazy, Suspense, useRef } from "react";
import { Provider } from "react-redux";
import * as ScreenOrientation from "expo-screen-orientation";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import * as Font from "expo-font";
import * as Updates from "expo-updates";
import * as SplashScreen from "expo-splash-screen";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { store } from "src/common/toolkit/store";
import { Loader } from "src/common/components";
import { LogBox, Platform } from "react-native";
import "react-native-gesture-handler";
import { TABLET_PC } from "src/common/libs/utils/constants";
import useAssets from "src/common/libs/hooks/useAssets";

import AppProvider from "./AppProvider";

LogBox.ignoreLogs(["Require cycle:"]);

let persistor = persistStore(store);
SplashScreen.preventAutoHideAsync();

export default function App() {
  const [fontsLoaded, setFontsLoaded] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [updatesLoaded, setUpdatesLoaded] = useState(false);

  const [images] = useAssets();

  useEffect(() => {
    if (Platform.OS !== "web" && TABLET_PC) {
      ScreenOrientation.lockAsync(ScreenOrientation.OrientationLock.LANDSCAPE);
    } else if (Platform.OS !== "web") {
      ScreenOrientation.lockAsync(
        ScreenOrientation.OrientationLock.PORTRAIT_UP
      );
    } else if (!TABLET_PC && Platform.OS === "web") {
      // ScreenOrientation.lockPlatformAsync({
      //   screenOrientationLockWeb: ScreenOrientation.WebOrientationLock.ANY
      // });
    }
    async function loadAssets() {
      try {
        await Font.loadAsync({
          Montserrat: require("./src/common/assets/Montserrat-Regular.ttf"),
        });
        await Font.loadAsync({
          MontserratBold: require("./src/common/assets/Montserrat-Bold.ttf"),
        });
        await Font.loadAsync({
          MontserratBlack: require("./src/common/assets/Montserrat-Black.ttf"),
        });
        await Font.loadAsync({
          InterRegular: require("./src/common/assets/Inter-Regular.ttf"),
        });
      } catch (e) {
      } finally {
        setFontsLoaded(true);
      }
    }

    async function loadUpdates() {
      try {
        const update = await Updates.checkForUpdateAsync();
        if (update.isAvailable) {
          await Updates.fetchUpdateAsync();
          await Updates.reloadAsync();
        }else{
          setUpdatesLoaded(true);
        }
      } catch (error) {
        setUpdatesLoaded(true);
      }
    }

    loadAssets();
    loadUpdates();

    return () => {
      if (Platform.OS !== "web") {
        ScreenOrientation.unlockAsync();
      }
    };
  }, []);

  useEffect(() => {
    if (images && !imagesLoaded) {
      setImagesLoaded(true);
    }
  }, [images]);

  if (!fontsLoaded || !imagesLoaded || !updatesLoaded) {
    return null;
  }

  const LoaderFallback = () => {
    return <Loader modal={false} full />;
  };

  return (
    <SafeAreaProvider style={{ overflow: "hidden" }}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<LoaderFallback />}>
            <AppProvider />
          </Suspense>
        </PersistGate>
      </Provider>
    </SafeAreaProvider>
  );
}
